<mat-card appearance="outlined">
  <div class="title-container">
    <mat-form-field *ngIf="isMain">
      <input [(ngModel)]="dynamicContent.title" matInput placeholder="{{'general.title' | translate}}" required/>
    </mat-form-field>
    <mat-form-field *ngIf="!isMain">
      <textarea [(ngModel)]="dynamicContent.title" matInput placeholder="{{'dynamicContent.question' | translate}}" required></textarea>
    </mat-form-field>
  </div>
  <ng-container *ngIf="!isMain">
    <div class="answers" *ngIf="answers" cdkDropList (cdkDropListDropped)="dropAnswer($event)">
      <ng-container *ngFor="let answer of dynamicContent.content.answers; let i = index">
        <div class="answer" [class.correct]="answer.isCorrect" cdkDrag cdkDragBoundary=".answers">
          <div class="drag-placeholder" *cdkDragPlaceholder></div>
          <div class="left">
            <ibex-checkbox [title]="'dynamicContent.quiz.correctAnswer' | translate" [checked]="answer.isCorrect"
              [disabled]="!answer.isCorrect && entranceConfig?.maxRightAnswers && getCorrectAnswerCount() >= entranceConfig?.maxRightAnswers"
              (click)="answer.isCorrect = $event.val"></ibex-checkbox>
            <span>{{answer.title}}</span>
          </div>
          <div class="right">
            <button class="drag ibexfusion-icon-button" mat-icon-button matTooltip="{{'packages.installedApps.dragTip'| translate}}">
              <mat-icon>drag_indicator</mat-icon>
            </button>
            <button (click)="removeAnswer(i)" mat-icon-button>
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
    <mat-form-field>
      <input type="text" matInput (change)="addAnswer($event)" [disabled]="maxAnswersReached()" [placeholder]="'dynamicContent.quiz.' + (maxAnswersReached() ? 'maxAnswer' : 'answer') | translate"/>
    </mat-form-field>
  </ng-container>
</mat-card>
